module.exports = __webpack_public_path__ + "img/s6_img2.7e893937.png";